import React from 'react';
import {connect} from 'react-redux';
import {Flex, SVGButton, UpgradeModal} from '/app/src/component';
import style from './style.css';
import ConversationModel from '/app/src/model/Conversation/model';
import ellipsis from '/app/src/lib/ellipsis'
import PaymentConfigHandler from '/app/src/config/PaymentConfigHandler'
import {CompanySelector} from '/app/src/model/selectors'
import {history} from '/app/src/store';

class FileInput extends React.Component
{
    constructor(props){
        super(props)
        this.state = {
            name: '',
            exist: false,
            showTryProModal: false
        }
        this.humanSize = PaymentConfigHandler.checkAccess('file', 'admin')

        this._handleChange = this._handleChange.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.unloadFile = this.unloadFile.bind(this);
    }

    humanFileSize(bytes, si) {
        var thresh = si ? 1000 : 1024;
        if(Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        var units = si
            ? ['kB','MB','GB','TB','PB','EB','ZB','YB']
            : ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];
        var u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while(Math.abs(bytes) >= thresh && u < units.length - 1);
        return bytes.toFixed(1)+' '+units[u];
    }

    _handleChange(event) {
        const reader = new FileReader()
        const file = event.target.files[0]
        const threshold = this.humanSize * 1000000 //Configuration specified in MB
        if (file) {
            if (file.size > threshold) {
                this.setState({showTryProModal: true})
                return
            }
            reader.onloadend = (evt) => {
                let blob = new Blob([new Uint8Array(evt.target.result)])
                this.setState({name: file.name, type: file.type, exist: true})
                this.blob = blob
                this.props.setFileBubbleText(ellipsis(file.name, 55) + ' ' + this.humanFileSize(file.size, true))
            }
            reader.readAsArrayBuffer(file)
        }
        //HACK: Allow to reupload same file consecutive times.
        event.target.value = ''
    }

    uploadFile(handleRequest){
        if(this.state.exist){
           ConversationModel.uploadFile(
                    this.props.room, this.state.type, this.state.name, this.blob, handleRequest
           )
           this.blob = null
           this.setState({name: '', exist: false})
        }
    }

    unloadFile() {
        this.blob = null;
        this.setState({name: '', exist: false});
        this.props.setFileBubbleText('');
    }

    render() {
        return(
            <Flex className={style.FileInputWrapper}>
                <input
                    onChange={this._handleChange}
                    className={style.FileInput + ' ' + this.props.className}
                    type="file"
                    id="file"
                />
                <label htmlFor="file">
                    <SVGButton
                        color='black'
                        hover='blue'
                        size='40px'
                        active={this.state.name}
                        src='/images/Upload.svg'
                    />
                </label>
                <UpgradeModal
                    open={this.state.showTryProModal}
                    contentType={this.props.currentPlan === "pro" ? "filesizePro" : "filesize"}
                    onClick={ () => history.push("/companySettings/upgrade")}
                    onClose={ () => this.setState({showTryProModal: false}) }/>
            </Flex>
        );
    }
}

function mapStateToProps(state, props) {
    return {
        currentPlan: CompanySelector.getPaymentPlan(state)

    }
}

export default connect(mapStateToProps, null, null, {withRef: true})(FileInput);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/Conversation/FileInput/index.js